import React,{useEffect,useRef} from 'react';
import {httpsCallable} from 'firebase/functions';
import {functions} from '../firebase';
import {useAuth} from '../contexts/AuthContext';

// Keeps platform/support agents discoverable while their Super Admin workspace is open.
// Online status is considered stale by clients after 90 seconds, so an abrupt tab close
// cannot leave an agent permanently online.
export default function SupportPresenceBridge({superAdmin=false}){
 const {profile}=useAuth();
 const disabledUntilRef=useRef(0);
 const inFlightRef=useRef(false);
 useEffect(()=>{
  if(!superAdmin||!profile?.id)return undefined;
  let stopped=false;
  const beat=async(status='online')=>{
   if(stopped||inFlightRef.current||Date.now()<disabledUntilRef.current)return;
   inFlightRef.current=true;
   try{
    await httpsCallable(functions,'setSupportPresence')({status});
    disabledUntilRef.current=0;
   }catch(error){
    // A missing/not-yet-deployed endpoint often surfaces in the browser as CORS/internal.
    // Back off for five minutes so one optional presence feature can never flood the app.
    disabledUntilRef.current=Date.now()+5*60*1000;
    if(process.env.NODE_ENV!=='production'&&!stopped)console.warn('Support presence temporarily disabled:',error?.code||error?.message||error);
   }finally{inFlightRef.current=false;}
  };
  beat('online');
  const timer=window.setInterval(()=>beat(document.visibilityState==='visible'?'online':'away'),60000);
  const visibility=()=>beat(document.visibilityState==='visible'?'online':'away');
  const focus=()=>beat('online');
  document.addEventListener('visibilitychange',visibility);window.addEventListener('focus',focus);
  return()=>{stopped=true;window.clearInterval(timer);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('focus',focus);};
 },[superAdmin,profile?.id]);
 return null;
}
